// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invResourceCategoryId } from './InvResourceCategory';
import { invResourceClassEnum } from './InvResourceClassEnum';
import { invItemOriginEnum } from './InvItemOriginEnum';
import { z } from 'zod';
export const invResourceId = (z.number());
export const invResource = z.object({
    id: invResourceId,
    name: z.string(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
    category_id: invResourceCategoryId.nullable(),
    'class': invResourceClassEnum,
    metadata: z.unknown().nullable(),
    origin_type: invItemOriginEnum,
    description: z.string().nullable(),
});
export const invResourceInitializer = z.object({
    id: invResourceId.optional(),
    name: z.string(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    category_id: invResourceCategoryId.optional().nullable(),
    'class': invResourceClassEnum,
    metadata: z.unknown().optional().nullable(),
    origin_type: invItemOriginEnum.optional(),
    description: z.string().optional().nullable(),
});
export const invResourceMutator = z.object({
    id: invResourceId.optional(),
    name: z.string().optional(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    category_id: invResourceCategoryId.optional().nullable(),
    'class': invResourceClassEnum.optional(),
    metadata: z.unknown().optional().nullable(),
    origin_type: invItemOriginEnum.optional(),
    description: z.string().optional().nullable(),
});
//# sourceMappingURL=InvResource.js.map